import {useEffect, useState, useRef} from 'react';
import {Link} from 'react-router';
import {handleNoSession} from "../../util/errorUtils";
import {getPlantStrains, insertPlantStrain} from "../../api/Api";
import {Button, Card, Table, Row, Input} from 'antd';
import {getColumnSearchProps} from "../widget/SearchProps";

export const PlantStrains = ({io, props}) => {
    const {refresh, onRefresh, onApiFail} = io;
    const [strains, setStrains] = useState([]);
    const [name, setName] = useState(undefined);
    const [description, setDescription] = useState(undefined);

    useEffect(() => {
        getPlantStrains().then(r => {
            setStrains(r.map(row => {
                return {...row, key: row.id}
            }))
        }).catch(e => {
            handleNoSession(e, onApiFail);
        })
    }, [refresh, onApiFail]);

    const searchInput = useRef(null);
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (val, record) => {
                return <Link to={`/cultivationapp/strain/${record.id}`}>{val}</Link>
            },
            ...getColumnSearchProps('name', searchInput),
            sorter: (a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description'
        },
    ]

    const tablePagination = {
        defaultPageSize: 50,
        showSizeChanger: true,
        pageSizeOptions: [50, 100, 150, 200]
    }

    const onNameChange = (e) => {
        setName(e.target.value);
    }

    const onDescriptionChange = (e) => {
        setDescription(e.target.value);
    }

    const onNewStrain = () => {
        insertPlantStrain(name, description).then(r => {
            clearForm();
            if (onRefresh) { onRefresh() }
        }).catch(e => {
            handleNoSession(e, onApiFail);
        })
    }

    const clearForm = () => {
        setName(undefined);
        setDescription(undefined);
    }

    const divStyle = {textAlign: 'left'}

    const rowStyle = {
        marginTop: '5px',
        marginBottom: '5px',
    }

    const okDisabled = (name === undefined) || (description === undefined);

    return <div style={divStyle}>
        <Card title={<b>Strains</b>}>
            <Table columns={columns} dataSource={strains} pagination={tablePagination} />
        </Card>
        <Card title={<b>New Strain</b>}>
            <Row style={rowStyle}>
                <Input style={{width: 600}} onChange={onNameChange} placeholder={'Name'} value={name}/>
            </Row>
            <Row style={rowStyle}>
                <Input style={{width: 600}} onChange={onDescriptionChange} placeholder={'Description'} value={description} />
            </Row>
            <Button onClick={onNewStrain} disabled={okDisabled}>Ok</Button>
        </Card>
    </div>
}